// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XLVl","importantInfo":"styles_importantInfo__26qNb"};